import { roleRoutes } from "utils/roles";
import { useAuthToken } from "../../providers/authProviders";
import { Navigate } from "react-router-dom";

/**
 * Permite el paso solo al perfil de display de sala "Centro de Control
 * Logístico IA" (rol controlTower). Es un carril de SOLO LECTURA: no comparte
 * el allowlist de RequireAdmin (que daría acceso a todo /admin/*).
 *
 * Admin/superadmin se incluyen para poder previsualizar/QA la pantalla sin
 * tener que loguearse con la cuenta de display.
 */
const allowedRoles = [
  roleRoutes.controlTower,
  roleRoutes.admin,
  roleRoutes.superadmin,
  roleRoutes.systemSuperadmin,
];

export default function RequireControlTower({ children }) {
  const { isAuthenticated, role } = useAuthToken();

  if (!isAuthenticated || !allowedRoles.includes(role)) {
    return <Navigate to="/" />;
  }

  return children;
}
